import { render, staticRenderFns } from "./AuditTable.vue?vue&type=template&id=d0906346&scoped=true"
import script from "./AuditTable.vue?vue&type=script&lang=js"
export * from "./AuditTable.vue?vue&type=script&lang=js"
import style0 from "./AuditTable.vue?vue&type=style&index=0&id=d0906346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0906346",
  null
  
)

export default component.exports